import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function Protected({ children, admin = false }) {
    const { user, loading } = useAuth();
    if (loading)
        return (
            <div className="min-h-screen grid place-items-center text-slate-500">
                Loading…
            </div>
        );
    if (!user) return <Navigate to="/login" replace />;
    if (admin && user.role !== "admin") return <Navigate to="/app/dashboard" replace />;
    return children;
}
